.container {
    height: 100%;
    width: 100%;
    max-width: 1200px;
}
